/**
 * 工事プランのボトムシート（snippets/aicon-plan-sheet.liquid）の開閉。
 *
 * ★ セクションの行内スクリプトから asset に出した（2026-08-25）★
 * シートを商品ページ（sections/aicon-product-buybox.liquid）とカート
 * （sections/aicon-cart-breakdown.liquid）の両方から出すようになったため。
 * 同じ開閉処理を2つのセクションに写して持たない。
 *
 * ★ 引き当ては data-aicon-plan-target（id）で行う ★
 * 旧実装は document.querySelector('[data-aicon-plan]') で**最初の1つ**を拾って
 * いたため、シートが2つ以上あるページでは別のシートを開きうる。
 * 起動側に開きたいシートの id を持たせて一意にする。
 *
 * ★ 参照は「押された時」に解決する ★
 * 旧実装は読み込み時に querySelector していたが、シート本体はスクリプトより
 * **後ろ**に出力されるため必ず null で、ハンドラが1つも登録されていなかった
 * （本番の実HTMLで確認。2026-08-24 の修正）。ここでも遅延参照を守る。
 *
 * ★ document で受ける（委譲）★
 * セクションの描き直し（テーマエディタ）でも張り直しが要らない。
 * 二重登録を防ぐためフラグを1つ置く。
 *
 * ★ aria-modal="true" と言い切る以上、フォーカスは閉じ込める（2026-08-25 レビュー指摘）★
 * シートは `position: fixed` で画面を覆うが DOM からは消えないため、Tab を押すと
 * **見えていない背面のリンクや購入ボタンにフォーカスが抜ける**。支援技術には
 * 「モーダル」と伝えているのに実際は抜けられる、という食い違いになる。
 * 閉じたあとは開く前に居た要素へ戻す（戻さないと body に落ちて、次の Tab が
 * ページ先頭から始まる）。
 */
(function () {
  if (window.__aiconPlanSheetBound) return;
  window.__aiconPlanSheetBound = true;

  /** 開いているシートを覚えておく。閉じるときに背面のスクロールを戻すため */
  var openSheet = null;
  /** 開く前にフォーカスが居た要素。閉じたときにそこへ戻す */
  var lastFocused = null;

  /**
   * シートの中の「Tab で止まる位置」を、ブラウザと同じ数え方で並べる。
   *
   * ★ タブの radio を含めること ★
   * `.aicon-plan__radio` は 1px + opacity:0 で隠しているが**フォーカスは受け取る**
   * （キーボードでタブを切り替える唯一の手段。CSS 側に
   *   `.aicon-plan__radio:focus-visible ~ .aicon-plan__tabs` の指定がある）。
   * `display:none` や `visibility:hidden` ではないので下の判定でも残る。
   *
   * ★★ 同じ name の radio は「グループで1か所」★★
   * ここを素直に全部数えると**トラップが抜ける**（実測 2026-08-25）。
   * ブラウザは radio グループの中で**checked の1つだけ**を Tab の停止位置にする。
   * 全部を数えると末尾が「checked でない radio B」になり、フォーカスがそこに
   * 来ることは無いので「末尾に居るか？」の判定が永遠に成立せず、
   * 実際には radio A の次の Tab で body へ抜けていた。
   * ∴ checked が居ればそれだけ、居なければ先頭だけを停止位置として数える。
   *
   * name の照合はセレクタを組まず JS で比べる（uid にセクションIDが入り、
   * CSS セレクタとしてエスケープが必要な文字が来ても壊れないようにする）。
   */
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function tabbables(sheet) {
    var candidates = Array.prototype.slice.call(sheet.querySelectorAll(FOCUSABLE));
    var radios = candidates.filter(function (el) {
      return el.type === 'radio' && el.name;
    });

    return candidates.filter(function (el) {
      // 出力されていない要素（タブで隠れている側のリストの中など）は飛ばす
      if (el.offsetWidth <= 0 && el.offsetHeight <= 0 && el !== document.activeElement) return false;
      if (el.type !== 'radio' || !el.name) return true;

      var group = radios.filter(function (r) {
        return r.name === el.name;
      });
      var checked = group.filter(function (r) {
        return r.checked;
      });
      return checked.length ? el.checked : el === group[0];
    });
  }

  function sheetFor(trigger) {
    var id = trigger.getAttribute('data-aicon-plan-target');
    if (id) return document.getElementById(id);
    // target が無いときは、起動ボタンと同じセクションの中のシートを探す
    var scope = trigger.closest('[data-aicon-plan-scope]') || document;
    return scope.querySelector('[data-aicon-plan]');
  }

  function open(sheet) {
    if (!sheet) return;
    lastFocused = document.activeElement;
    sheet.hidden = false;
    // 背面をスクロールさせない。閉じたときに必ず戻す
    document.body.style.overflow = 'hidden';
    openSheet = sheet;
    var closeButton = sheet.querySelector('.aicon-plan__close');
    if (closeButton) closeButton.focus();
  }

  function close(sheet) {
    if (!sheet) return;
    sheet.hidden = true;
    document.body.style.overflow = '';
    if (openSheet === sheet) openSheet = null;
    // 開く前に居た場所へ戻す。消えている（テーマエディタの差し替え等）なら何もしない
    if (lastFocused && typeof lastFocused.focus === 'function' && lastFocused.isConnected) {
      lastFocused.focus();
    }
    lastFocused = null;
  }

  /**
   * Tab / Shift+Tab をシートの中で回す。
   *
   * ★ 「端に居るときだけ止める」ではなく、Tab を全部こちらで処理する ★
   * 端の判定に頼るとネイティブの数え方（radio グループ・非表示要素の扱い）と
   * 1つでも食い違った瞬間に外へ抜ける。移動先を毎回自分で決めれば食い違わない。
   * このシートの操作対象は「閉じる」＋タブ2つだけなので、奪っても失うものが無い。
   */
  function trap(event) {
    var items = tabbables(openSheet);
    event.preventDefault();
    if (!items.length) return;

    var n = items.length;
    var i = items.indexOf(document.activeElement);
    var next;
    if (event.shiftKey) {
      // シートの外に居た（i === -1）ときは末尾から入る
      next = i <= 0 ? n - 1 : i - 1;
    } else {
      next = i < 0 || i === n - 1 ? 0 : i + 1;
    }
    items[next].focus();
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var opener = event.target.closest('[data-aicon-plan-open]');
    if (opener) {
      open(sheetFor(opener));
      return;
    }

    var closer = event.target.closest('[data-aicon-plan-close]');
    if (closer) close(closer.closest('[data-aicon-plan]'));
  });

  document.addEventListener('keydown', function (event) {
    if (!openSheet) return;
    // Esc で閉じる
    if (event.key === 'Escape') {
      close(openSheet);
      return;
    }
    if (event.key === 'Tab') trap(event);
  });
})();
